import React, { useEffect, useState } from 'react';
import { contactService } from '@/api/services/contactService';
import { ContactList } from '@/components/contacts/ContactList';
import { Card } from '@/components/ui/card';
import { ContactsHeader } from '@/components/contacts/ContactsHeader';
import { ContactListControls } from '@/components/contacts/ContactListControls';
import { Skeleton } from '@/components/ui/skeleton';
import { Button } from '@/components/ui/button';
import { usePageHeader } from '@/contexts/PageHeaderContext';
import { Crown } from 'lucide-react';
const Customers = () => {
  const {
    setHeaderData
  } = usePageHeader();
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    const totalCustomers = customers.length;
    const activeCustomers = customers.filter((customer: any) => customer.status === 'active').length;
    const premiumCustomers = customers.filter((customer: any) => customer.tier === 'premium').length;
    setHeaderData({
      title: 'Customers',
      description: 'Manage your customer base and track their engagement',
      icon: Crown,
      stats: [{
        label: 'Total Customers',
        value: totalCustomers,
        color: 'text-gray-900',
        dotColor: 'bg-blue-500'
      }, {
        label: 'Active',
        value: activeCustomers,
        color: 'text-green-600',
        dotColor: 'bg-green-500'
      }, {
        label: 'Premium',
        value: premiumCustomers,
        color: 'text-yellow-600',
        dotColor: 'bg-yellow-500'
      }]
    });
  }, [customers, setHeaderData]);
  useEffect(() => {
    setLoading(true);
    contactService.fetchCustomers().then(res => {
      setCustomers(res.data || []);
      setLoading(false);
    }).catch(err => {
      setError(err.message || 'Failed to load customers');
      setLoading(false);
    });
  }, []);
  if (loading) {
    return <div className="p-6">
        <Card className="p-4">
          <Skeleton className="h-4 w-80" />
          <Skeleton className="h-4 w-60" />
          <Skeleton className="h-8 w-full" />
        </Card>
      </div>;
  }
  if (error) {
    return <div className="p-6">
        <Card className="p-4 text-red-500">
          <p>Error loading customers: {error}</p>
          <Button onClick={() => {
          setError(null);
          setLoading(true);
          contactService.fetchCustomers().then(res => {
            setCustomers(res.data || []);
            setLoading(false);
          }).catch(err => {
            setError(err.message || 'Failed to load customers');
            setLoading(false);
          });
        }} className="mt-2">
            Retry
          </Button>
        </Card>
      </div>;
  }
  return <div className="h-screen overflow-y-auto container mx-auto px-4 py-6 max-w-[1400px]">
      
      <Card className="p-6">
        <ContactListControls />
        <ContactList contacts={customers} loading={loading} />
      </Card>
    </div>;
};
export default Customers;